import $ from 'jquery';
import axios from 'axios';

export default class News {
    constructor($news, options = {}) {
        this.options = $.extend(true, {
            classes: {
                list: 'news__list'
            },
        },
            this.state = {
                isLoading: false, // true if any loading is on page
            },
            options);

        if (!$news) {
            return;
        }

        this.$news = $news;
        this.$list = this.$news.querySelector('.' + this.options.classes.list);

        this.init(this);
    }

    init() {

        const $this = this;
        const page = new URLSearchParams(window.location.search).get('page') || '1';

        let config = {
            headers: {
                'Accept': '*/*',
                'X-Requested-With': 'XMLHttpRequest',
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
            }
        }

        this.toggleLoader(true);

        axios.get('?page=' + page, config)
            .then(function (response) {

                console.log('1st response:', response);

                if (response.data.toLowerCase().includes('<html')) {
                    axios.get('?page=' + page, config)
                        .then(function (response2) {
                            console.log('2nd response:', response2);

                            if (response2.data.toLowerCase().includes('<html')) {
                                console.log('Second request has no effect');
                                // setTimeout(()=> {
                                //     window.location.reload();
                                // }, 3000);
                            } else {
                                $this.$list.innerHTML = response2.data;
                            }

                            $this.toggleLoader(false);
                        })
                        .catch(function (error) {
                            console.log('error:', error);
                            $this.toggleLoader(false);
                        });
                } else {
                    $this.$list.innerHTML = response.data;
                    $this.toggleLoader(false);
                }
            })
            .catch(function (error) {

                console.log('error:', error);
                $this.toggleLoader(false);
            });
    }

    toggleLoader(state) {
        this.state.isLoading = state;
        this.$news.classList.toggle('filter-block--loading', state);

        if (state) {
            this.$news.insertAdjacentHTML('beforeend', '<div class="loader"></div>')
        } else {
            this.$news.querySelector('.loader').remove();
        }
    }
}


// WEBPACK FOOTER //
// ./front/treasurybond/js/components/news/news.js